<template>
    <Portal>
        <template v-if="myUser">
            <CCard class="profile">
                <CCardBody>
                    <CForm @submit.prevent="onSubmit">
                        <CRow>
                            <CCol lg="4">
                                <CCard>
                                    <CCardHeader>
                                        <strong>Profile</strong>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInput
                                                    required
                                                    label="Username"
                                                    name="username"
                                                    :is-valid="errors.usernameIsValid"
                                                    :invalid-feedback="errors.usernameInvalidFeedback"
                                                    v-model="myUser.username"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Full name"
                                                    :is-valid="errors.fullNameIsValid"
                                                    :invalid-feedback="errors.fullNameInvalidFeedback"
                                                    v-model="myUser.fullName"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <label>
                                                    Country
                                                </label>
                                                <v-select
                                                    class="profile-select"
                                                    style="height:35px"
                                                    :options="countries"
                                                    :reduce="country => country.code"
                                                    label="name"
                                                    :is-valid="errors.countryIsValid"
                                                    :invalid-feedback="errors.countryInvalidFeedback"
                                                    v-model="myUser.country"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Club"
                                                    :is-valid="errors.clubNameIsValid"
                                                    :invalid-feedback="errors.clubNameInvalidFeedback"
                                                    v-model="myUser.clubName"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow class="form-group">
                                            <CCol tag="label" class="col-form-label">
                                                Crew
                                            </CCol>
                                        </CRow>
                                        <CRow class="mb-4">
                                            <CCol sm="6">
                                                <CInputCheckbox
                                                    label="1x"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.crew1xFlagIsValid"
                                                    :invalid-feedback="errors.crew1xFlagInvalidFeedback"
                                                    :checked.sync="myUser.crew1xFlag"
                                                />
                                                <CInputCheckbox
                                                    label="4x/4-"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.crew4x4mFlagIsValid"
                                                    :invalid-feedback="errors.crew4x4mFlagInvalidFeedback"
                                                    :checked.sync="myUser.crew4x4mFlag"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInputCheckbox
                                                    label="2x/2-"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.crew2x2mFlagIsValid"
                                                    :invalid-feedback="errors.crew2x2mFlagInvalidFeedback"
                                                    :checked.sync="myUser.crew2x2mFlag"

                                                />
                                                <CInputCheckbox
                                                    label="8+"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.crew8pFlagIsValid"
                                                    :invalid-feedback="errors.crew8pFlagInvalidFeedback"
                                                    :checked.sync="myUser.crew8pFlag"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow class="form-group">
                                            <CCol tag="label" class="col-form-label">
                                                Who I am
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInputCheckbox
                                                    label="Coach"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.coachFlagIsValid"
                                                    :invalid-feedback="errors.coachFlagInvalidFeedback"
                                                    :checked.sync="myUser.coachFlag"

                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInputCheckbox
                                                    label="Athlete"
                                                    custom
                                                    class="mb-2"
                                                    :is-valid="errors.athleteFlagIsValid"
                                                    :invalid-feedback="errors.athleteFlagInvalidFeedback"
                                                    :checked.sync="myUser.athleteFlag"
                                                />
                                            </CCol>
                                        </CRow>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                            <CCol lg="4">
                                <CCard>
                                    <CCardHeader>
                                        <strong>Body params</strong>
                                    </CCardHeader>
                                    <CCardBody>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Height (cm)"
                                                    :is-valid="errors.heightCmIsValid"
                                                    :invalid-feedback="errors.heightCmInvalidFeedback"
                                                    v-model="myUser.heightCm"
                                                    type="number"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Weight (kg)"
                                                    :is-valid="errors.weightKgIsValid"
                                                    :invalid-feedback="errors.weightKgInvalidFeedback"
                                                    v-model="myUser.weightKg"
                                                    type="number"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Wingspan (cm)"
                                                    :is-valid="errors.wingspanCmIsValid"
                                                    :invalid-feedback="errors.wingspanCmInvalidFeedback"
                                                    v-model="myUser.wingspanCm"
                                                    type="number"
                                                />
                                            </CCol>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Leg length (cm)"
                                                    :is-valid="errors.legLengthCmIsValid"
                                                    :invalid-feedback="errors.legLengthCmInvalidFeedback"
                                                    v-model="myUser.legLengthCm"
                                                    type="number"
                                                />
                                            </CCol>
                                        </CRow>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                            <CCol lg="4">
                                <CCard>
                                    <CCardHeader>
                                        <strong>Personal Information</strong>
                                    </CCardHeader>
                                    <CCardBody class="pb-5">
                                        <!--                                        <CRow>-->
                                        <!--                                            <CCol>-->
                                        <!--                                                <CInput-->
                                        <!--                                                        label="Date of birth"-->
                                        <!--                                                        type="date"-->
                                        <!--                                                        :is-valid="errors.birthDateIsValid"-->
                                        <!--                                                        :invalid-feedback="errors.birthDateInvalidFeedback"-->
                                        <!--                                                        v-model="myUser.birthDate"-->
                                        <!--                                                />-->
                                        <!--                                            </CCol>-->
                                        <!--                                        </CRow>-->
                                        <CRow class="form-group">
                                            <CCol tag="label" class="col-form-label">
                                                Gender
                                            </CCol>
                                        </CRow>
                                        <CRow class="mb-3 radio-profile">
                                            <CCol class="mb-2">
                                                <CInputRadioGroup
                                                    class="d-flex flex-wrap"
                                                    custom
                                                    :options="[
                                                            {value: 'Female', label: 'Female'},
                                                            {value: 'Male', label: 'Male'} ,
                                                            {value: 'PreferNotToSay', label: 'Prefer not to say'}
                                                            ]"
                                                    :is-valid="errors.genderIsValid"
                                                    :invalid-feedback="errors.genderInvalidFeedback"
                                                    :checked.sync="myUser.gender"
                                                    :value="myUser.gender"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="6">
                                                <CInput
                                                    label="Phone number"
                                                    :is-valid="errors.phoneIsValid"
                                                    :invalid-feedback="errors.phoneInvalidFeedback"
                                                    v-model="myUser.phone"
                                                />
                                            </CCol>
                                        </CRow>
                                        <CRow class="form-group" style="padding-bottom:3px;">
                                            <CCol tag="label" style="cursor:pointer" class="col-form-label"
                                                  @click="changeEmailShown=!changeEmailShown">
                                                Change email (login)
                                                <img src="../assets/img/sort-down.svg" alt="">
                                            </CCol>
                                        </CRow>
                                        <CRow v-show="changeEmailShown">
                                            <CCol>
                                                <CInput
                                                    label="New email (Attention, by changing email you change your login!)"
                                                    name="email"
                                                    type="email"
                                                    :is-valid="errors.emailIsValid"
                                                    :invalid-feedback="errors.emailInvalidFeedback"
                                                    v-model="myUser.email"
                                                />
                                            </CCol>
                                        </CRow>

                                        <CRow class="form-group" style="padding-bottom:3px;">
                                            <CCol tag="label" style="cursor:pointer" class="col-form-label"
                                                  @click="changePasswordShown=!changePasswordShown">
                                                Change password
                                                <img src="../assets/img/sort-down.svg" alt="">
                                            </CCol>
                                        </CRow>
                                        <template v-if="changePasswordShown">
                                            <CRow>
                                                <CCol>
                                                    <CInput
                                                        required
                                                        class="align-items-center"
                                                        horizontal
                                                        type="password"
                                                        autocomplete="off"
                                                        label="Old password"
                                                        v-model="oldPassword"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol>
                                                    <CInput
                                                        required
                                                        class="align-items-center"
                                                        horizontal
                                                        type="password"
                                                        autocomplete="off"
                                                        label="New password"
                                                        v-model="newPassword1"
                                                    />
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol>
                                                    <CInput
                                                        required
                                                        class="align-items-center"
                                                        horizontal
                                                        type="password"
                                                        autocomplete="off"
                                                        label="Repeat new password"
                                                        v-model="newPassword2"
                                                    />
                                                </CCol>

                                            </CRow>
                                            <CRow>
                                                <CCol style="text-align:center">
                                                    <FormErrors :errors="changePasswordErrors"/>
                                                    <FormSuccess :show="changePasswordSuccess">Password was changed</FormSuccess>
                                                    <CButton class="px-5" color="success" @click="changePasswordOnSubmit">
                                                        Change password
                                                    </CButton>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </CCardBody>
                                </CCard>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol style="text-align:center">
                                <FormErrors :errors="errors.nonFieldErrors"/>
                                <FormSuccess :show="success">Settings saved</FormSuccess>
                                <CButton type="submit" class="px-5" color="success">SAVE</CButton>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
            </CCard>
        </template>
    </Portal>
</template>

<script>
    import Portal from '@/components/layouts/Portal'
    import {store, eventBus} from '@/scripts/globals'
    import {getProcessedResponseErrors, onSubmitHandler} from '@/scripts/forms-utils'
    import gql from 'graphql-tag'
    import FormErrors from '@/components/FormErrors'
    import FormSuccess from '@/components/FormSuccess'
    import countries from '@/assets/countries'
    import {getProcessedAuthResponseErrorsFlat} from '@/scripts/auth-utils'

    function getCopiedAndCleanedMyUser() {
        let myUserPropertiesNames = [
            'email',
            'username',
            'fullName',
            'clubName',
            'country',
            'crew1xFlag',
            'crew2x2mFlag',
            'crew4x4mFlag',
            'crew8pFlag',
            'coachFlag',
            'athleteFlag',
            'heightCm',
            'weightKg',
            'legLengthCm',
            'wingspanCm',
            'phone',
            'gender',
            'birthDate'
        ]
        let myUser = {}

        for (let propName of myUserPropertiesNames) {
            myUser[propName] = store.myUser[propName]
        }

        return myUser
    }

    export default {
        components: {
            FormErrors,
            FormSuccess,
            Portal
        },
        data() {
            return {
                errors: {},
                success: false,
                myUser: getCopiedAndCleanedMyUser(),
                store,
                countries,
                changePasswordShown: false,
                changeEmailShown: false,
                changePasswordSuccess: false,
                changePasswordErrors: false,
                oldPassword: '',
                newPassword1: '',
                newPassword2: ''
            }
        },
        watch: {
            'store.myUser': function () {
                this.myUser = getCopiedAndCleanedMyUser()
            }
        },
        methods: {
            async onSubmit() {
                // noinspection ES6ShorthandObjectProperty
                let mutation = gql`
                    mutation updateUser ($updateUser: UpdateUserInputType!){
                        updateUser (updateUser: $updateUser) {
                            success
                            errors
                        }
                    }
                `
                await onSubmitHandler(this, mutation,
                    {
                        onSuccessF: (res, scope) => {
                            scope.success = true
                            eventBus.$emit('forceUpdateUserProfile')
                        },
                        onStartF: (scope) => scope.success = false,
                        setErrorsF: (errors, scope) => scope.errors = getProcessedResponseErrors(errors,
                            ['email', 'username', 'fullName', 'clubName', 'country',
                                'crew1xFlag', 'crew2x2mFlag', 'crew4x4mFlag', 'crew8pFlag',
                                'coachFlag', 'athleteFlag', 'heightCm', 'weightKg',
                                'legLengthCm', 'wingspanCm', 'phone', 'birthDate', 'gender', 'nonFieldErrors'
                            ]),
                        mutationVariables: {'updateUser': this.myUser}
                    }
                )
            },
            async changePasswordOnSubmit() {
                let mutation = gql`
                    mutation {
                        changePassword (
                            oldPassword: "${this.oldPassword}",
                            newPassword1: "${this.newPassword1}",
                            newPassword2: "${this.newPassword2}"
                        ) {
                            success
                            errors
                        }
                    }
                `
                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.changePasswordErrors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.changePasswordSuccess = true,
                        onStartF: (scope) => scope.changePasswordSuccess = false
                    })
            }
        }
    }
</script>


<style lang="scss">
    @media (min-width: 992px) and (max-width: 1200px) {
        .profile {
            .form-row {
                flex-direction: column;

                .col-form-label, .col-sm-9 {
                    max-width: 100% !important;
                }
            }
        }
    }

    .profile {
        &-avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: #dce0e7;

            .badge {
                border-radius: 50%;
                position: absolute;
                top: 0;
                right: -5px;
                width: 20px;
                height: 20px;
                padding: 4px 5px;
                z-index: 2;
                background-color: #ccc;
            }
        }
    }

    .form-group {
        position: relative;

        .invalid-feedback {
            position: absolute;
            margin-top: 0;
        }
    }
</style>
